import { jsx } from 'react/jsx-runtime';
import { font, themedColor } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import { rgba } from 'polished';
import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { ALTERNATIVE_LINKS_BY_REGION } from '../../../config/links.esm.js';
import { useRenderCookieRelatedItem } from './FooterContentLinks.esm.js';
import { useNavContext } from '../../../providers/NavProvider.esm.js';
import { useCommonI18nContext, useI18nContext } from '../../../providers/I18nProvider.esm.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    padding-left: 16px;\n    border-left: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: ",
        ";\n  flex-wrap: wrap;\n  border-left: none;\n\n  ",
        "\n\n  li a,\n  li, button {\n    ",
        ";\n    color: ",
        ";\n    text-decoration: none;\n    white-space: nowrap;\n    border: none;\n    background: transparent;\n    padding: 0;\n    margin: 0;\n    cursor: pointer;\n\n    &:hover {\n      text-decoration: underline;\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var ListWrapper = styled.ul(_templateObject1(), font("main", {
    fontSize: "1.4rem",
    lineHeight: "2.1rem"
}), themedColor("metal"), MEDIA_QUERIES.desktop(_templateObject(), function(props) {
    return "solid 1px ".concat(rgba(props.theme.colors.metal, 0.5));
}), font("main", {
    fontSize: "1.4rem",
    lineHeight: "2.1rem"
}), themedColor("metal"), themedColor("metal"));
var AlternativeLinks = function() {
    var nav = useNavContext().nav;
    var t = useCommonI18nContext().t;
    var _useRenderCookieRelatedItem = useRenderCookieRelatedItem(), renderCookiesRelatedItem = _useRenderCookieRelatedItem.renderCookiesRelatedItem, isCookieRelatedItem = _useRenderCookieRelatedItem.isCookieRelatedItem, onManageCookiesClick = _useRenderCookieRelatedItem.onManageCookiesClick;
    var _useState = _sliced_to_array(useState(false), 2), isClient = _useState[0], setIsClient = _useState[1];
    var region = useI18nContext().region;
    useEffect(function() {
        setIsClient(true);
    }, []);
    return /*#__PURE__*/ jsx(ListWrapper, {
        children: ALTERNATIVE_LINKS_BY_REGION[region].map(function(item) {
            if (isCookieRelatedItem(item)) {
                return /*#__PURE__*/ jsx("li", {
                    style: {
                        display: renderCookiesRelatedItem(item) && isClient ? "flex" : "none"
                    },
                    children: /*#__PURE__*/ jsx("button", {
                        "data-event": "footer_".concat(item, "_clicked"),
                        onClick: function() {
                            return onManageCookiesClick(item === "do_not_share_my_personal_information");
                        },
                        type: "button",
                        children: t("nav.".concat(item, ".title"))
                    })
                }, item);
            }
            return /*#__PURE__*/ jsx("li", {
                children: /*#__PURE__*/ jsx("a", {
                    "data-event": "footer_".concat(item, "_clicked"),
                    href: nav[item],
                    children: t("nav.".concat(item, ".title"))
                })
            }, item);
        })
    });
};

export { AlternativeLinks };
